import React from 'react';
import fadeInAndOut from 'src/components/animations/SkeletonFadeInAndOut';
import styled from 'styled-components';
import { TEST_ID_PRICE_CHART_PREVIEW } from '../../constants';

const columnArray = [
  21, 32, 28, 28, 23, 17, 11, 15, 41, 15, 32, 28, 23, 28, 34, 20, 34, 28, 28,
  28, 32, 21, 15, 34, 15, 25, 11, 28, 23, 23, 23, 32, 41, 28, 28, 21,
] as const;

export const PriceChartPreview = (): JSX.Element => (
  <Container data-testid={TEST_ID_PRICE_CHART_PREVIEW}>
    <ColumnsContainer>
      {columnArray.map((height, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <ColumnLoader $columnHeight={height} key={index} />
      ))}
    </ColumnsContainer>
    <TextContainer>
      <TextLoader />
      <TextLoader />
    </TextContainer>
  </Container>
);

const Container = styled.div`
  display: block;
  height: fit-content;
`;

const ColumnsContainer = styled.div`
  display: flex;
  height: 45px;
  width: 100%;
  align-items: flex-end;

  & div + div {
    margin-left: 1px;
  }
`;

const TextContainer = styled.div`
  display: flex;
  height: 36px;
  width: 100%;
  flex-direction: column;
  align-items: center;
  margin-top: 3px;
  justify-content: space-around;
`;

const TextLoader = styled.div`
  height: 1px;
  width: 60px;
  background-color: #e6e6e6;
  position: relative;
  overflow: hidden;

  animation: ${fadeInAndOut} 1200ms ease-in-out infinite;
`;

const ColumnLoader = styled.div<{ $columnHeight: number }>`
  flex: 1;
  height: ${({ $columnHeight }) => `${$columnHeight}px`};
  background-color: #e6e6e6;

  position: relative;
  overflow: hidden;

  animation: ${fadeInAndOut} 1200ms ease-in-out infinite;
`;
